const getRoiValueCalculatorEmailFormName = require("./getRoiValueCalculatorEmailFormName");
const sendFormSubmissionValidationErrorEmailToFormsAtIterableCom = require("../email/sendFormSubmissionValidationErrorEmailToFormsAtIterableCom");

/**
 * @param roiGateFormData {RoiGateFormData}
 * @return {Promise<void>}
 */
module.exports = async function sendRoiGateFormSubmissionValidationErrorEmailToFormsAtIterableCom(roiGateFormData) {
    const form = getRoiValueCalculatorEmailFormName();
    const email = roiGateFormData["Email"];
    const marketoFormId = roiGateFormData["formid"];
    await sendFormSubmissionValidationErrorEmailToFormsAtIterableCom(form, email, marketoFormId, roiGateFormData);
}